import React from "react";
import { observer } from "mobx-react";
import { UploadedContentTemplate } from "themes/administration/uploaded-content/pages";
import { UploadedContentViewStore } from "administration/uploaded-content/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new UploadedContentViewStore(rootStore, componentProps),
    "uploadedContentViewStore"
)
@observer
class UploadedContentPage extends React.Component {
    render() {
        return <UploadedContentTemplate {...this.props} />;
    }
}

export default UploadedContentPage;
